import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    type: "light",
    primary: {
      main: "#0b7474",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#00AEEF",
    },
    text: {
      secondary: "#808285",
    },
    dropdownTriangle: {
      300: "#BDBDBD",
      400: "#757575",
    },
  },
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#CF1322", //red-500
        "&$error": {
          color: "#CF1322", //red-500
        },
      },
    },
    MuiInputLabel: {
      root: {
        color: "#94A3B8", // muted / secondary label
        "&$focused": {
          color: "#0F172A", //text-primary
        },
        "&$error": {
          color: "#CF1322", //red-500
        },
        "&$shrink": {
          color: "#0F172A", // keep floating label muted too
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        "& $notchedOutline": {
          borderColor: "#CBD5E1", //surface-200
        },
        "&:hover $notchedOutline": {
          borderColor: "#64748B", //surface-400
        },
        "&.Mui-focused $notchedOutline": {
          borderColor: "#64748B", //surface-400
        },
        "&.Mui-error $notchedOutline": {
          borderColor: "#8C221C", //red-600
        },
        "&.Mui-disabled $notchedOutline": {
          borderColor: "transparent",
        },
      },
    },
  },
});

export default theme;
